import React, { Component } from 'react'
import MembershipPackage from './membershipPackage'
import MentoringPackage from './mentoringPackage'
import FreeTrial from './FreeTrial'
import { StyledMember, StyledContent } from './style'

class PackageDetails extends Component<Props> {
  
  componentWillMount() {
    if (this.props.match.params.packageId === 'freetrial') {
      this.props.history.push({
        pathname: '/checkout',
        state: {
          packageId: 4,
          packageName: 'Free Trial',
          price: 0,
          planLength: '',
          planType: 'recurring'
        }
      })
    }
  }

  render() {
    const packageId = this.props.match.params.packageId
    return (
      <StyledContent>
        <StyledMember>
          {packageId === '1on1mentoring' && <MentoringPackage />}
          {(packageId === 'membershipmonthly' || packageId === 'membershipyearly') && <MembershipPackage packageId={packageId === 'membershipmonthly' ? '2' : '3'} />}
          {(packageId === 'freetrial') && <FreeTrial />}
        </StyledMember>
      </StyledContent>
    )
  }
}

export default PackageDetails



// WEBPACK FOOTER //
// ./src/components/shop-pages/PackageDetails.js